import { httpGet, httpPost, httpDelete } from "@/request/http";

let path = "/accounts";

export default {
  getPages(dTO) {
    return httpGet(`${path}/pages`, dTO);
  },
  get(id) {
    return httpGet(`${path}/${id}`);
  },
  getNames() {
    return httpGet(`${path}/names`);
  },
  save(item) {
    return httpPost(path, item);
  },
  remove(id) {
    return httpDelete(`${path}/${id}`);
  },
};
